<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaDeviceDialog',
})
</script>
<template>
	<ma-data-table
		:key="visible + ''"
		v-model:visible="visible"
		row-key="id"
		:title="t('componentsModule.maDevice.selectDevice')"
		url="/maku/biz_device/page"
		method="post"
		:multiple
		:default-selected="defaultSelected"
		:columns="[
			// { field: 'id', label: t('componentsModule.maDevice.deviceId') },
			{ field: 'name', label: t('componentsModule.maDevice.deviceName') },
			{ field: 'number', label: t('componentsModule.maDevice.number') },
			{ field: 'location', label: t('componentsModule.maDevice.location') }
		]"
		:query-params="[
			{ field: 'name', label: t('componentsModule.maDevice.deviceName'), type: 'input' },
			{ field: 'orgId', label: t('componentsModule.maDevice.department'), type: 'org' },
			{ field: 'keyType', label: t('componentsModule.maDevice.keyType'), type: 'dict', dict: 'device_key_type' }
		]"
		@select="onSelect"
	></ma-data-table>
</template>

<script setup lang="ts" name="MaDeviceDialog">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
defineProps({
	multiple: {
		type: Boolean,
		required: false,
		default: false
	},
	defaultSelected: {
		type: Array,
		required: false,
		default: () => []
	}
})

const visible = defineModel<boolean>()

const emit = defineEmits(['select'])
const onSelect = (rows: any[]) => {
	emit('select', rows)
}
</script>
